import React from 'react';
import { Icon } from '@ohif/ui';
import VoiceRecording from '../../../../../../platform/app/src/routes/voice-dictation/VoiceRecording';
import { MicOff } from 'lucide-react';

const VoiceRecordingComponent = VoiceRecording as any;

interface VoiceDictationControlsProps {
    voiceRecordingRef: React.RefObject<any>;
    isFocusedInsideReport: boolean;
    onVoiceInput: (text: string, isFinal?: boolean) => void;
    isContentLoaded?: boolean;
    isLoading?: boolean;
    isVisible?: boolean;
    className?: string;
}

const VoiceDictationControls: React.FC<VoiceDictationControlsProps> = ({
    voiceRecordingRef,
    isFocusedInsideReport,
    onVoiceInput,
    isContentLoaded = true,
    isLoading = false,
    isVisible = true,
    className = ''
}) => {
    // Don't render if not visible or if content is not loaded
    if (!isVisible || !isContentLoaded || isLoading) {
        return null;
    }

    const isListening = voiceRecordingRef.current?.isListening?.();
    const shouldBlur = !isFocusedInsideReport && !isListening;

    return (
        <div
            className={`flex items-center gap-2 transition-opacity duration-300 ${className}`}
            id="report-voice-dictation"
            onMouseDown={(e) => {
                e.preventDefault();
            }}
        >
            {shouldBlur ? (
                <MicOff
                    className="mic-button mic-default mic-off-icon p-2"
                />
            ) : (
                <VoiceRecordingComponent
                    ref={voiceRecordingRef}
                    variant="default"
                    onText={onVoiceInput}
                    disabled={shouldBlur}
                    className="p-2 mic-enabled"
                />
            )}
        </div>
    );
};

export default VoiceDictationControls;
